import { SEARCH_ALGO } from 'constants/index';
import { useTenantConfig } from 'contexts';
import {
  checkCurrentPageIsExcluded,
  getCookieByName,
  getEnv,
  isServerless,
} from 'helpers';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

// hook use mainly for A/B testing new discovery search algorithm
export const useSearchAlgo = () => {
  const { enableSearchAlgoABTesting } = useTenantConfig();
  const router = useRouter();
  const noDefaultSortOption =
    getEnv('SEARCH_ALGO_NO_DEFAULT_SORT_OPTION') || '';

  const getSearchAlgoFromCookie = () => {
    return isServerless() &&
      !!enableSearchAlgoABTesting &&
      !checkCurrentPageIsExcluded(router.pathname)
      ? getCookieByName(SEARCH_ALGO.COOKIE)?.replace(
          SEARCH_ALGO.REPLACE_PATTERN,
          '',
        )
      : undefined;
  };

  const noActiveDefaultSortOption = useMemo(() => {
    return (
      noDefaultSortOption === 'enabled' &&
      !checkCurrentPageIsExcluded(router.pathname)
    );
  }, [noDefaultSortOption, router.pathname]);

  const getDefaultSortOption = (defaultSortOptionCode?: string) => {
    return !!noActiveDefaultSortOption ? undefined : defaultSortOptionCode;
  };

  return {
    noActiveDefaultSortOption,
    getSearchAlgoFromCookie,
    getDefaultSortOption,
  };
};
